import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(24 * 3600);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="bg-urgency text-white py-2 px-4 sticky top-0 z-[60]" data-id="element-121">
      <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 text-xs md:text-sm font-medium" data-id="element-122">
        <span data-id="element-123">
          ⚠️ OFFERTA DI LANCIO: Risparmia il 70% solo per le prossime 24 ore!
        </span>
        <span className="font-heading font-extrabold bg-white/15 px-2.5 py-0.5 rounded-brand font-mono tracking-wider" data-id="element-124">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}